export {
  declarationsApiSlice,
  useGetMostRecentDeclarationsQuery,
} from "./declarations";
